import { Currency } from "./constants/api";

export const renderCurrencyChar = (currency: string | undefined): string => {
  if (currency == null || currency === "") {
    return "";
  }
  switch (currency.toLowerCase()) {
    case Currency.US_DOLLAR:
      return "$";
    case Currency.AU_DOLLAR:
      return "AUD";
    default:
      return "$";
  }
};
